import { FOLLOW_ON_OFFERING_TYPES } from '../../../../../../types/domain/offering/constants';
import {
  OfferingDetails_PublishedOffering_FilingsFragment,
  OfferingDetails_PublishedOffering_FollowOnPricingFragment,
  OfferingDetails_PublishedOfferingFragment,
} from '../../../../../offering-side-panel/offering-details/graphql/__generated__';
import { FollowOnPairs } from './components/FollowOnPairs';
import { IpoPricePair } from './components/IpoPair';

type PricePairsProps = {
  offeringType: OfferingDetails_PublishedOfferingFragment['type'];
  latestFilling?: OfferingDetails_PublishedOffering_FilingsFragment;
  followOnPricing?: OfferingDetails_PublishedOffering_FollowOnPricingFragment | null;
  pricingCurrencyCode: OfferingDetails_PublishedOfferingFragment['pricingCurrencyCode'];
};

export function PricePairs({
  offeringType,
  latestFilling,
  followOnPricing,
  pricingCurrencyCode,
}: Readonly<PricePairsProps>) {
  if (FOLLOW_ON_OFFERING_TYPES.includes(offeringType)) {
    return (
      <FollowOnPairs
        latestFilling={latestFilling}
        followOnPricing={followOnPricing}
        pricingCurrencyCode={pricingCurrencyCode}
      />
    );
  }
  return <IpoPricePair latestFilling={latestFilling} pricingCurrencyCode={pricingCurrencyCode} />;
}
